import { MatrixParameterValue } from "../interfaces/MatrixInputCell";

const textCustomValidator = (cell: MatrixParameterValue, callback: (valid: boolean) => void) => {
  callback(true);
};

export default textCustomValidator;
